export const coloresBase = {
    colorPrincipal: '#1A28D7',
    colorSecundario: '#D6E8FF',
    color3: '#FDFFAE',
    color4: '#D2FAFF',
    color5: '#F67F8C',
    color6: '#F8FBFF',
    color7: '#F4EFEF',
    color8: '#444',
    color9: '#94BDF2'
};